import type { ComponentType } from "react";
import type { SectionProps } from "@/flash/context";
import SysContact from "./contact";
import SysNavbar from "./nav";
import { SysEvidence, SysManifesto, SysSystem } from "./story";
import { SysChapters } from "./chapters";
import { SysCta, SysFaq, SysFooter, SysTestimonials } from "./closing";
import { SysChapterList, SysCtaBand, SysNotFound, SysPageIntro, SysSteps, SysUnified, SysValue } from "./subpages";

/** Editorial layouts used for the tech style. The hero itself stays in sections.tsx (MagneticHero). */
export const SYSTEM_RENDERERS: Record<string, ComponentType<SectionProps>> = {
  navbar: SysNavbar,
  features: SysManifesto,
  cases: SysEvidence,
  showcase: SysChapters,
  gallery: SysSystem,
  testimonials: SysTestimonials,
  faq: SysFaq,
  cta: SysCta,
  contact: SysContact,
  footer: SysFooter,
  pageintro: SysPageIntro,
  steps: SysSteps,
  unified: SysUnified,
  chapterlist: SysChapterList,
  value: SysValue,
  ctaband: SysCtaBand,
  notfound: SysNotFound,
};